import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import api from '@/lib/api';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = window.location.hash;
        const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');
        if (!sessionId) {
          navigate('/login', { replace: true });
          return;
        }

        const res = await api.post('/auth/session', { session_id: sessionId });
        setUser(res.data);
        navigate('/home', { replace: true, state: { user: res.data } });
      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="glass rounded-[24px] p-8 flex flex-col items-center gap-4 animate-fade-in">
        <Loader2 className="w-10 h-10 animate-spin text-[#6C4CF1]" />
        <p className="text-[#4B5563] font-medium text-lg">Signing you in...</p>
      </div>
    </div>
  );
}
